module.exports = __webpack_public_path__ + "static/img/11areaB_12.f3fac2a.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/11areaB_12.png
// module id = 1092
// module chunks = 1